(function () {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  document.documentElement.style.scrollBehavior = 'unset';
  window.scrollTo({
    top: 0,
  });
  document.documentElement.style.scrollBehavior = '';
  if (document.querySelector('#start-test')) document.querySelector('#start-test').addEventListener('click', validateCustomerForm);

  function validateCustomerForm() {
    var form = document.querySelector('.customer-form');
    var genderInput = form.querySelector('[name="gender"]:checked');
    if (form.checkValidity() === true) {
      filterQuestions(genderInput.value);
      document.querySelector('[data-questions-list] .question-item-row:not([style="display: none;"])').scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    }
  }

  function filterQuestions(gender, remove = false) {
    $('.qeustions-list').removeClass('qeustions-list--disabled');
    $('.question-item-row').hide();
    $('.question-item-row[data-gender="' + gender + '"]').show();
    orderQuestions(gender);
  }

  function orderQuestions(gender) {
    var questions = document.querySelectorAll(`[data-questions-list] .question-item-row[data-gender="${gender}"]`);
    questions.forEach((item, i) => {
      var tabTitle = item.querySelector('.tab-title p');
      if (tabTitle.querySelector('span')) tabTitle.querySelector('span').remove();
      tabTitle.innerHTML = '<span>' + (i + 1).toString() + '- </span>' + tabTitle.innerHTML;
    });
  }
  $('.js-reload').click(function (e) {
    localStorage.removeItem('yourRecommendedProducts');
    window.location.reload();
  });
  var indexesArray = [];
  var values = [];
  $('body').on('click', '.quiz-option-click', function (e) {
    var questionid = $(this).val();
    var elementid = $(this).data('elementid');
    if (this.closest('[data-multible-choice]')) {
      $(this).parent().toggleClass('selected');
      if (this.closest('[data-multible-choice] .selected')) {
        $('#Question' + elementid).addClass('checked');
      } else {
        $('#Question' + elementid).removeClass('checked');
      }
    } else {
      $('.quiz-option' + questionid)
        .parent()
        .removeClass('selected');
      $(this).parent().addClass('selected');
      $('#Question' + elementid).addClass('checked');
    }
    e.preventDefault();
    var questionsElss = $('[data-question-element]:visible');
    var selectedQuestionsElss = $('.checked[data-question-element]:visible');
    if (selectedQuestionsElss.length === questionsElss.length) {
      // console.log("calling getResultApp");
      // console.log("multible-choice: ", this.closest("[data-multible-choice]"));
      if (this.closest('[data-multible-choice]')) {
        document.querySelector('.test-submit-btn').classList.remove('hidden');
      } else {
        getResultApp();
        goNext('');
      }
    } else {
      goNext('');
    }
  });
  document.querySelector('.test-submit-btn').addEventListener('click', function () {
    getResultApp();
    document.querySelector('[data-questions-list]').style.pointerEvents = 'none';
    document.querySelector('[data-questions-list]').style.opacity = '0.7';
    document.querySelector('.test-submit-btn').style.pointerEvents = 'none';
    document.querySelector('.test-submit-btn').style.opacity = '0.5';
  });
  window.appUrl = 'https://o2morny-personality-test-cdbc14059c99.herokuapp.com';

  function getResultApp(answers) {
    console.log('getResultApp', answers);

    // Determine which test we're on
    var testNumberElement = document.querySelector('[data-test-number]');
    if (!testNumberElement) {
      console.error('Test number element not found');
      return;
    }

    var textNumber;
    if (testNumberElement.dataset.testNumber == '1') {
      var answers = $('.tab-option.selected:visible button')
        .map(function () {
          return this.getAttribute('data-item-id');
        })
        .get();
      textNumber = 1;
    } else {
      var answers = $('.tab-option.selected:visible button:not(.tab-option--submitted)')
        .map(function () {
          return this.getAttribute('data-item-id');
        })
        .get();
      textNumber = 2;
    }

    // Prepare API request. The browser only sends an origin-level Referer on
    // cross-origin POSTs, so the upstream API can't infer the storefront
    // locale from headers. Pass it explicitly so phase 2 content is fetched
    // in the user's language (e.g. /ar/pages/personality-test-phase-2).
    var url = window.appUrl + '/api/personality-test';
    var locale =
      (window.Shopify && window.Shopify.locale) ||
      document.documentElement.getAttribute('lang') ||
      '';
    var data = {
      answers: answers,
      'test-number': textNumber,
      locale: locale,
    };

    if (textNumber == 2) {
      data.personalities = JSON.parse(window.personalities);
    } else {
      data.name = $('[name="customer[first_name]"]').val();
      data.email = $('[name="customer[email]"]').val();
      data.gender = $('[name="gender"]:checked').val();
    }

    // Show loading spinner
    var tabResult = $('#tab-result');
    var loadingContainer = tabResult.find('.loading-container');

    if (loadingContainer.length > 0) {
      loadingContainer.removeClass('hidden');
      tabResult.removeClass('hidden'); // Make sure tab-result is visible

      // Scroll to loading spinner
      $('html,body').animate(
        {
          scrollTop: loadingContainer.offset().top - 105,
        },
        'slow',
      );
    }

    // Disable submit button to prevent double submission
    var submitBtn = document.querySelector('.test-submit-btn');
    if (submitBtn) {
      submitBtn.style.pointerEvents = 'none';
      submitBtn.style.opacity = '0.5';
    }

    var startTime = performance.now();

    // Make API request
    fetchReq(url, data)
      .then((res) => {
        if (!res.ok) {
          throw new Error('API request failed: ' + res.status);
        }
        return res.json();
      })
      .then((response) => {
        console.log('API Response received:', response);

        // Hide loading spinner
        loadingContainer.addClass('hidden');

        // Re-enable submit button
        if (submitBtn) {
          submitBtn.style.pointerEvents = '';
          submitBtn.style.opacity = '';
        }

        if (data['test-number'] == 1) {
          // Phase 1 complete - inject Phase 2 questions
          console.log('Phase 1 complete, loading Phase 2 questions...');

          testNumberElement.dataset.testNumber = '2';
          $('.tab-option.selected:visible').closest('.question-item-row').addClass('question--submitted');
          $('.tab-option.selected:visible button').addClass('tab-option--submitted');

          // Store Phase 1 results
          window.personalities = response.personalities;
          window.test_1_result = response.testResult;
          window.customerId = response.customer_id;
          window.customerState = response.customer_state;

          // Inject new questions
          var questionsListContainer = $('.qeustions-list [data-questions-list]');

          if (response.section && questionsListContainer.length > 0) {
            questionsListContainer.append(response.section);

            // Filter questions based on gender
            var selectedGender = $('[name="gender"]:checked').val();
            if (selectedGender) {
              filterQuestions(selectedGender, true);
            }

            // Hide loading and show message
            tabResult.addClass('hidden');

            // Scroll to first new question
            setTimeout(function () {
              var firstNewQuestion = $('[data-questions-list] .question-item-row:not(.question--submitted):visible').first();
              if (firstNewQuestion.length > 0) {
                $('html,body').animate(
                  {
                    scrollTop: firstNewQuestion.offset().top - 100,
                  },
                  'slow',
                );
              }
            }, 300);

            console.log('Phase 2 questions loaded successfully');
          } else {
            console.error('No section data received or container not found');
            tabResult.addClass('hidden');
          }
        } else {
          // Phase 2 complete - show product results
          console.log('Phase 2 complete, loading product recommendations...');
          tabResult.hide();

          if (response.subfamily) {
            buildResultProducts(response.subfamily);
          } else {
            console.error('No subfamily data received');
          }
        }

        var endTime = performance.now();
        console.log('API call took ' + (endTime - startTime).toFixed(2) + ' milliseconds');
      })
      .catch((error) => {
        console.error('Error in getResultApp:', error);

        // Hide loading spinner
        loadingContainer.addClass('hidden');

        // Re-enable submit button
        if (submitBtn) {
          submitBtn.style.pointerEvents = '';
          submitBtn.style.opacity = '';
        }

        // Show error message to user
        var resultContainer = tabResult.find('#result');
        if (resultContainer.length > 0) {
          resultContainer.html(
            '<div style="text-align: center; padding: 40px; color: #e74c3c;">' +
              '<h3>حدث خطأ</h3>' +
              '<p>عذراً، حدث خطأ أثناء معالجة الاختبار. يرجى المحاولة مرة أخرى.</p>' +
              '<button class="btn js-reload" style="margin-top: 20px;">إعادة المحاولة</button>' +
              '</div>',
          );
          tabResult.removeClass('hidden');
        }
      });
  }

  function buildResultProducts(subFamily_ar) {
    console.log('subFamily_ar', subFamily_ar);

    // Validate input
    if (!subFamily_ar || !Array.isArray(subFamily_ar) || subFamily_ar.length === 0) {
      console.error('Invalid subfamily array received');
      return;
    }

    // Translate subfamilies
    var responseSubFamilies = [window.subFamilies_locales[subFamily_ar[0].trim()]];
    console.log('responseSubFamilies', responseSubFamilies);

    if (subFamily_ar[1]) {
      responseSubFamilies.push(window.subFamilies_locales[subFamily_ar[1].trim()]);
    }

    // Validate translations
    if (!responseSubFamilies[0]) {
      console.error('Failed to translate subfamily:', subFamily_ar[0]);
      return;
    }

    // Get container and validate
    var container = document.querySelector('.personality-section-collection');
    if (!container) {
      console.error('Results container not found');
      return;
    }
    console.log('container', container);

    // Get gender with validation
    var genderInput = document.querySelector('[name="gender"]:checked');
    if (!genderInput) {
      console.error('Gender not selected');
      return;
    }
    var genderFilter = genderInput.value.replace('Female', 'Women').replace('Male', 'Men');

    // Build URL with proper encoding
    var u =
      window.routes.routes_url_without_slash + '/collections/personality-test?filter.p.m.custom.sub_family=' + encodeURIComponent(responseSubFamilies[0]) + '&view=test-filter';
    console.log('u', u);

    if (responseSubFamilies[1]) {
      u = u + '&filter.p.m.custom.sub_family=' + encodeURIComponent(responseSubFamilies[1]);
    }

    u = u + '&filter.p.m.custom.gender=' + encodeURIComponent(genderFilter);
    container.classList.remove('hidden');

    // Fetch products
    fetch(u)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Network response was not ok: ' + response.status);
        }
        return response.text();
      })
      .then(function (h) {
        if (!h || h.trim() === '') {
          console.warn('No products returned from collection');
          return;
        }

        // Update product loop
        var productLoop = container.querySelector('.product-loop');
        if (!productLoop) {
          console.error('Product loop container not found');
          return;
        }
        productLoop.innerHTML = h;

        // Remove loading spinner
        var loadingSpinner = container.querySelector('.glider.loading');
        if (loadingSpinner) {
          loadingSpinner.remove();
        }

        // Scroll back up to the results now that the product cards are visible.
        // After Phase 2 the page is left scrolled down near the loading/footer
        // area, so bring the user up to the recommendations header.
        var resultsScrollTarget = container.querySelector('#recommended') || container;
        if (resultsScrollTarget) {
          $('html,body').animate(
            {
              scrollTop: $(resultsScrollTarget).offset().top - 105,
            },
            'slow',
          );
        }

        // Get products count with validation
        var productsCountInput = container.querySelector('[name="products-count"]');
        var productsCount = productsCountInput ? productsCountInput.value : '0';

        // Update count displays
        var countElements = container.querySelectorAll('.your-products-count');
        if (countElements.length > 0) {
          countElements.forEach((item, i) => {
            item.textContent = productsCount;
          });
        }

        // Update "View All" link
        var viewAllLink = container.querySelector('#test-products-all');
        if (viewAllLink) {
          var viewAllLinkHref = u.replace('test-filter', 'test-results');
          viewAllLink.href = viewAllLinkHref;

          // Save to localStorage
          try {
            localStorage.setItem('testAllProductsLink', viewAllLinkHref);
          } catch (error) {
            console.warn('Failed to save link to localStorage:', error);
          }
        }

        // Save products count
        try {
          localStorage.setItem('productsCount', productsCount);
        } catch (error) {
          console.warn('Failed to save count to localStorage:', error);
        }

        // Collect and save product IDs
        var productElements = container.querySelectorAll('.product-loop [data-product-id]');

        if (productElements.length > 0) {
          // Get existing items from localStorage
          var existingItems = [];
          try {
            existingItems = JSON.parse(localStorage.getItem('yourRecommendedProducts') || '[]');
          } catch (error) {
            console.warn('Failed to parse existing products from localStorage:', error);
            existingItems = [];
          }

          // Use Set to avoid duplicates
          var itemsSet = new Set(existingItems);

          productElements.forEach((element) => {
            var productId = parseInt(element.dataset.productId, 10);
            if (!isNaN(productId)) {
              itemsSet.add(productId);
            }
          });

          // Convert Set to Array and keep only last 4 items
          var allItems = Array.from(itemsSet);
          var lastFourItems = allItems.slice(-4);

          // Save to localStorage
          try {
            localStorage.setItem('yourRecommendedProducts', JSON.stringify(lastFourItems));
            console.log('Saved recommended products:', lastFourItems);
          } catch (error) {
            console.error('Failed to save products to localStorage:', error);
          }
        }
      })
      .catch(function (err) {
        console.error('Failed to fetch products:', err);
        container.classList.add('hidden');
        // TODO: Show user-friendly error message
      });
  }

  function fetchReq(url, data = {}) {
    // console.log(data);
    return fetch(url, {
      body: JSON.stringify(data),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
  }

  function goNext(result) {
    var questions = $('[data-question-element]:visible');
    var questionsLength = $('[data-question-element]:visible').length;
    var next = false;
    for (var i = 0; i < questionsLength && next == false; i++) {
      if (!questions.eq(i).hasClass('checked')) {
        $('html,body').animate(
          {
            scrollTop: questions.eq(i).offset().top - (window.innerHeight - questions.eq(i).height()) / 2 + 50,
          },
          'slow',
        );
        next = true;
      }
    }
    if (!next) {
      $('#title-result').html(result.title);
      $('#description-result').html(result.content);
      $('#img-result').attr('src', result.image);
      $('#tab-result').css('display', 'flex');
      $('#tab-reload').css('display', 'block');
      $(':button').prop('disabled', true);
      $('html,body').animate(
        {
          scrollTop: $('#tab-result').offset().top - 105,
        },
        'slow',
      );
    }
  }
  window.subFamilies_locales = {
    'اروماتيك حمضي': 'Aromatic Citrusy',
    'اروماتيك خشبي': 'Aromatic Woody',
    'اروماتيك سبايسي': 'Aromatic Spicy',
    'اروماتيك عشبي': 'Aromatic Herbal',
    'اروماتيك فاكهي': 'Aromatic Fruity',
    'اروماتيك فوجير': 'Aromatic Fougere',
    'اروماتيك مائي': 'Aromatic Aquatic',
    'تشيبر زهري': 'Chypre Floral',
    'تشيبر فاكهي': 'Chypre Fruity',
    'حمضي اروماتك': 'Citrusy Aromatic',
    'حمضي فاكهي': 'Citrusy Fruity',
    'خشبي اروماتك': 'Woody Aromatic',
    'خشبي اروماتيك': 'Woody Aromatic',
    'خشبي تشيبر': 'Woody Chypre',
    'خشبي حمضي': 'Woody Citrusy',
    'خشبي زهري': 'Woody Floral',
    'خشبي سبايسي': 'Woody Spicy',
    'خشبي شرقي': 'Woody Oriental',
    'خشبي عشبي': 'Woody Herbal',
    'خشبي مائي': 'Woody Aquatic',
    'زهري حمضي': 'Floral Citrusy',
    'زهري خشبي': 'Floral Woody',
    'زهري شرقي': 'Floral Oriental',
    'زهري عشبي': 'Floral Herbal',
    'زهري فاكهي': 'Floral Fruity',
    'زهري مائي': 'Floral Aquatic',
    شرقي: 'Oriental',
    'شرقي اروماتك': 'Oriental Aromatic',
    'شرقي اروماتيك': 'Oriental Aromatic',
    'شرقي حمضي': 'Oriental Citrusy',
    'شرقي خشبي': 'Oriental Woody',
    'شرقي زهري': 'Oriental Floral',
    'شرقي سبايسي': 'Oriental Spicy',
    'شرقي عشبي': 'Oriental Herbal',
    'شرقي فاكهي': 'Oriental Fruity',
    'شرقي فوجير': 'Oriental Fougere',
  };

  try {
    fetch(window.appUrl + '/o2morny-test');
  } catch (e) {
    console.log(e);
  }

  class yourRecommendedProducts extends HTMLElement {
    constructor() {
      super();

      // Get query string from localStorage
      const queryString = this.getSearchQueryString();
      console.log('queryString', queryString);

      // If no saved products, don't show anything
      if (queryString === '') {
        return;
      }

      // Get and validate container
      var container = this.closest('.personality-section-collection');
      if (!container) {
        console.error('Container not found for your-recommended-products');
        return;
      }

      // Show results container
      container.classList.remove('hidden');

      // Hide other sections (store references to avoid double querying)
      var personalityTestSection = document.querySelector('[data-section-type="personality-test"]');
      if (personalityTestSection) {
        personalityTestSection.classList.add('hidden');
      }

      var imageWithTextH3 = document.querySelector('[data-section-type="image_with_text"] h3');
      if (imageWithTextH3) {
        imageWithTextH3.classList.add('hidden');
      }

      var videoSection = document.querySelector('[data-section-type="video"]');
      if (videoSection) {
        videoSection.classList.add('hidden');
      }

      // Setup intersection observer for lazy loading
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(this);

        // Fetch products
        fetch(this.dataset.url + queryString)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Failed to fetch recommended products');
            }
            return response.text();
          })
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recentlyViewed = html.querySelector('your-recommended-products');

            if (recentlyViewed && recentlyViewed.innerHTML.trim().length) {
              // Update this element's content
              this.innerHTML = recentlyViewed.innerHTML;

              // Hide loading spinner
              var loadingSpinner = container.querySelector('.glider.loading');
              if (loadingSpinner) {
                loadingSpinner.classList.add('hidden');
              }

              // Update product count from localStorage
              var savedCount = localStorage.getItem('productsCount');
              if (savedCount) {
                var count = parseInt(savedCount, 10);
                if (!isNaN(count)) {
                  var countElements = document.querySelectorAll('.your-products-count');
                  if (countElements.length > 0) {
                    countElements.forEach((item) => {
                      item.textContent = count;
                    });
                  }
                }
              }

              // Update "View All" link
              var viewAllLink = container.querySelector('#test-products-all');
              var savedLink = localStorage.getItem('testAllProductsLink');

              if (viewAllLink && savedLink) {
                viewAllLink.href = savedLink;
              }
            }
          })
          .catch((error) => {
            console.error('Error loading recommended products:', error);
            // Hide container if loading fails
            container.classList.add('hidden');
          });
      };

      // Observe this element
      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }

    getSearchQueryString() {
      var items = [];

      try {
        items = JSON.parse(localStorage.getItem('yourRecommendedProducts') || '[]');
      } catch (error) {
        console.error('Failed to parse yourRecommendedProducts from localStorage:', error);
        return '';
      }

      if (!Array.isArray(items) || items.length === 0) {
        return '';
      }

      return items
        .map(function (item) {
          return 'id:' + item;
        })
        .join(' OR ');
    }
  }
  customElements.define('your-recommended-products', yourRecommendedProducts);
  try {
    $('body').on('click', '#start-test', function (evt) {
      ga('send', {
        hitType: 'event',
        eventCategory: 'TestPage',
        eventAction: 'StartTest',
      });
    });
    $('body').on('click', '.js-test-submit', function (evt) {
      // console.log(this);
      ga('send', {
        hitType: 'event',
        eventCategory: 'TestPage',
        eventAction: 'SubmitTest',
      });
    });
    $('body').on('click', '.tab-option', function (evt) {
      // console.log(this);
      var eventLbale = this.querySelector('.tab-option-button-text') ? this.querySelector('.tab-option-button-text').innerText : 'checkbox';
      ga('send', {
        hitType: 'event',
        eventCategory: 'TestPage',
        eventAction: 'Answer Click',
        eventLabel: eventLbale,
      });
    });
  } catch (e) {
    console.log(e);
  }
  try {
    window.addEventListener('load', (event) => {
      ga('send', {
        hitType: 'event',
        eventCategory: 'TestPage',
        eventAction: 'Page view',
      });
    });
  } catch (e) {
    console.log(e);
  }
})();
